import { memo } from "react";

function CircleSolid({ className = "", size = 18, color = "currentColor" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 36 36"
      width={size}
      height={size}
      fill={color}>
      <path
        d="M18 4a14 14 0 1 0 14 14A14 14 0 0 0 18 4z"
        className="clr-i-solid clr-i-solid-path-1"
      />
    </svg>
  );
}
export default memo(CircleSolid);
